import Container from "../core/Container"
import Heading from "../core/Heading"
import Paragraph from "../core/Paragraph"
import SectionTag from "../core/SectionTag"
import Button from "../core/Button"
import Image from "../core/Image"
import Link from "../core/Link"
import { useNavigate } from "react-router-dom"

export default function Services() {
    const navigate = useNavigate()

    const services = [
        {
            title: "Webináře",
            description: (
                <>
                    Online vzdělávací akce zaměřené na <span className="font-bold text-main">digitální dovednosti</span>, <span className="font-bold text-main">umělou inteligenci</span> a <span className="font-bold text-main">moderní technologie</span>. Ideální pro ty, kteří preferují flexibilní formu vzdělávání z pohodlí domova.
                </>
            ),
            features: [
                "Interaktivní online prostředí",
                "Záznamy pro pozdější zhlédnutí",
                "Praktické ukázky a materiály",
                "Možnost klást otázky v reálném čase",
                "Osvědčení o absolvování"
            ],
            icon: "💻",
            color: "main"
        },
        {
            title: "Semináře",
            description: (
                <>
                    Prezenční vzdělávací akce s praktickým zaměřením na <span className="font-bold text-main">kancelářské balíčky</span>, <span className="font-bold text-main">algoritmizaci</span>, <span className="font-bold text-main">umělou inteligenci</span> a <span className="font-bold text-main">vzdělávací aplikace</span>.
                </>
            ),
            features: [
                "Osobní přístup lektora",
                "Skupinové aktivity a workshopy",
                "Praktické materiály a pomůcky",
                "Možnost klást otázky v reálném čase",
                "Osvědčení o absolvování"
            ],
            icon: "📚",
            color: "second"
        },
        {
            title: "Konzultace",
            description: (
                <>
                    Individuální nebo skupinové konzultace zaměřené na konkrétní potřeby klientů. Pomáháme s implementací <span className="font-bold text-main">digitálních řešení</span>, rozvojem <span className="font-bold text-main">digitálních kompetencí</span> a <span className="font-bold text-main">nasazením Edupage</span>.
                </>
            ),
            features: [
                "Šitý na míru vašim potřebám",
                "Flexibilní časové rozvržení",
                "Odborné poradenství",
                "Dlouhodobá podpora"
            ],
            icon: "🤝",
            color: "main_light"
        }
    ]

    return(
        <Container bgColor="transparent" className="w-full py-16 md:py-24">
            <Container bgColor="transparent" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Heading Section */}
                <SectionTag>Služby</SectionTag>
                <Container bgColor="transparent" className="mt-4 mb-10 max-w-3xl">
                    <Heading variant="h2" className="mb-3">
                        Jak vám pomáháme vzdělávat bez stresu
                    </Heading>
                    <Paragraph className="text-gray-700">
                        Pro učitele, školy a organizace připravujeme webináře, semináře i individuální konzultace, které propojují digitální nástroje a pedagogiku. Vyberte si formu, která vám nejvíc vyhovuje.
                    </Paragraph>
                </Container>

                <Container bgColor="gray-50" radius="xl" shadow className="relative overflow-hidden p-4 sm:p-6 md:p-8 lg:p-10 mt-6 sm:mt-8 mb-8 border-l-4 border-main">
                    <div className="absolute inset-y-0 right-0 pointer-events-none opacity-10 sm:opacity-20">
                        <div className="h-full w-40 bg-gradient-to-l from-main to-transparent blur-3xl" />
                    </div>

                    <div className="inline-flex items-center gap-2 rounded-full bg-main_light/20 px-3 py-1 mb-4">
                        <span className="text-xs font-semibold uppercase tracking-wide text-main">Novinka</span>
                        <span className="text-xs text-main">Mikrolearning pro učitele</span>
                    </div>

                    <Heading variant="h2" className="mb-3">
                        Mikrolearning: digitální dovednost za 45 minut
                    </Heading>

                    <Paragraph className="text-gray-700 mb-3">
                        Od března zařazujeme nový formát webinářů – <span className="font-bold text-main">mikrolearning</span>. Krátké, praktické lekce, které vám nezaberou celé odpoledne.
                    </Paragraph>

                    <ul className="mb-4 space-y-1 text-sm text-gray-700">
                        <li>• Žádné nekonečné teorie a dlouhé úvody – <span className="font-bold">jdeme rovnou k věci</span>.</li>
                        <li>• Za <span className="font-bold text-main">45 minut</span> získáte konkrétní digitální dovednost, kterou ihned využijete v přípravě i hodině.</li>
                        <li>• <span className="font-bold">Krátce, úderně a bez stresu</span> – přesně ve stylu DigiBezStresu.</li>
                    </ul>

                    <div className="flex flex-wrap gap-3">
                        <Button 
                            variant="primary"
                            size="lg"
                            onClick={() => {
                                navigate('/kurzy')
                                window.scrollTo({ top: 0, behavior: 'smooth' })
                            }}
                        >
                            Podívat se na mikrolearning webináře
                        </Button>
                        <span className="text-xs sm:text-sm text-gray-500 p-4">
                            Nejbližší termíny najdete v přehledu kurzů.
                        </span>
                    </div>
                </Container>

                {/* Decorative DigiBoy Image - úplně vpravo za kartami */}
                <Container bgColor="transparent" className="absolute top-0 right-0 lg:right-0 z-0 opacity-20 lg:opacity-30 pointer-events-none hidden md:block">
                    <Image
                        src="./img/digiboy_oldman.png"
                        alt="DigiBoy decoration"
                        className="w-48 lg:w-64 h-auto"
                    />
                </Container>

                {/* Cards Grid */}
                <Container bgColor="transparent" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 relative z-10">
                    {services.map((service, index) => (
                        <Container
                            key={index}
                            bgColor="white"
                            radius="lg"
                            shadow
                            className="p-6 lg:p-8 hover:shadow-lg transition-shadow duration-300 flex flex-col"
                        >
                            {/* Icon */}
                            <Container bgColor="transparent" className="mb-4">
                                <div className="text-5xl mb-4">{service.icon}</div>
                                <Heading variant="h3" className="text-2xl font-bold text-gray-900 mb-3">
                                    {service.title}
                                </Heading>
                            </Container>

                            {/* Description */}
                            <Container bgColor="transparent" className="mb-6 flex-grow">
                                <Paragraph className="text-gray-700 leading-relaxed">
                                    {service.description}
                                </Paragraph>
                            </Container>

                            {/* Features */}
                            <Container bgColor="transparent" className="mb-6">
                                <ul className="space-y-2">
                                    {service.features.map((feature, idx) => (
                                        <li key={idx} className="flex items-start text-sm text-gray-600">
                                            <span className="text-main mr-2">✓</span>
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </Container>
                        </Container>
                    ))}
                </Container>

                {/* CTA pod kartami – odkaz na celou nabídku kurzů */}
                <Container bgColor="transparent" className="mt-10 flex justify-center">
                    <Link 
                        to="/kurzy"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                        <Button variant="primary" size="lg" className="px-8">
                            Prozkoumat vypsané kurzy
                        </Button>
                    </Link>
                </Container>

                <Container bgColor="main_light" className="mt-10 flex flex-col justify-center w-full py-6 px-2 rounded-lg text-center">
                    <Heading variant="h2" color="white">
                    💰 Naše webináře a kurzy je možné hradit z OP JAK II. (šablony) a ONIV 💰
                    </Heading>
                    <Paragraph variant="small_white_bold">
                        Pokud máte zájem o tuto službu, tak nás informujte v poznámce přihlášky.
                    </Paragraph>

                </Container>
            </Container>
        </Container>
    )
}